// extracted by mini-css-extract-plugin
module.exports = {"header":"User_header__3CdC5","grid":"User_grid__Js02Y","icon":"User_icon__2nr2_"};